/*
Default shape of the Vuex root state.

XOL-446: this MUST be produced by a factory, not shared as a module literal.
Before XOL-446 `main.js` did `value = defaultStore` by reference on a cold
boot and then wrote `env` / `endpoint` / `hostname` / ... into it, so
`store.state === defaultStore` and `setTokens()` wrote live JWTs into this
module's object. Any reset that cloned `defaultStore` would then have
resurrected the very tokens it was meant to erase. Call `makeDefaultStore()`
and you always get a private object.

`defaultStore` is kept as an eagerly-built instance for the handful of
existing importers; new code should call the factory.
------------------------------------------------------------------------ */

export function makeDefaultStore () {
  return {
    isLoggedIn: false,
    xolasClient: {},
    org: {},
    profile: {},
    stats: {},
    statsError: false,
    debug: false,
    isChrome: null,
    isSafari: null,
    env: null,
    endpoint: null,
    hostname: null,
    copyright: null,
    windowWidth: null,
    windowHeight: null,
    // XOL-446: `baseMap` used to be attached dynamically in main.js's client
    // fetch, so it was absent from a freshly-reset state — and GoogleMap.vue
    // reads `getStore().baseMap.lat` unguarded. Declare it with the same
    // fallback the fetch uses so a reset can never introduce that crash.
    baseMap: { lat: 3.0, lng: 105.0 },
    // KAN-39/XOL-151: JWT auth. NOT persisted via vuex-persistedstate (we don't want two copies);
    // tokens live in localStorage, written by src/lib/auth.js.
    auth: {
      accessToken: null,
      refreshToken: null,
      claims: null,
      expiresAt: null
    }
  }
}

export const defaultStore = makeDefaultStore()
